/**
 * Capture the screen the user was on when they opened the report sheet.
 *
 * The captured string lands on `reportproblems.screencontext`. We map the
 * current path to a short, human-readable label while retaining the raw route.
 * This reads `window.location`, so it belongs to the web Report Problems module.
 */

import { routes } from '../../routes/paths';

const ROUTE_LABELS: Array<{ match: (path: string) => boolean; label: string }> = [
  { match: (p) => p === routes.home || p === '/' || p === routes.plan, label: 'Shopping list' },
  { match: (p) => p.startsWith(routes.deals), label: 'Deals' },
  { match: (p) => p.startsWith(routes.trip), label: 'Trip' },
  { match: (p) => p.startsWith(routes.products), label: 'Your products' },
  { match: (p) => p.startsWith(routes.cards), label: 'Cards' },
  { match: (p) => p === routes.feedback, label: 'Feedback' },
  { match: (p) => p.startsWith(routes.settings), label: 'Settings' },
];

/** Build a friendly screen-context string for the current or supplied path. */
export function captureScreenContext(pathname?: string): string {
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '/');
  const friendly = ROUTE_LABELS.find((route) => route.match(path));
  return friendly ? `${friendly.label} (${path})` : path;
}
